import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';

@Pipe({
  name: 'orderBy',
  pure: false,
  standalone: false,
})
export class OrderByPipe implements PipeTransform {
  transform<T>(
    array: Array<T>,
    property: string,
    sortOrder: 'asc' | 'desc',
  ): T[] {
    return orderBy(array, [property], [sortOrder]);
  }
}
